export default class ClipStore {
  prevId = undefined;
  nextId = undefined;
  currentId = undefined;

  next() {}
  prev() {}
}
// SAAS only
